import { DrawAPI } from '../../../api/schematicmap/DrawAPI';

export class DrawCommand {
    generate(edition, data, successCallback, errorCallback) {
        const apiResult = DrawAPI.generate(edition, data);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(result);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    list(edition, successCallback, errorCallback) {
        const apiResult = DrawAPI.list(edition);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(fileName, successCallback, errorCallback) {
        const apiResult = DrawAPI.delete(fileName);
        apiResult.then(() => {
            if ("function" === typeof successCallback) {
                successCallback("Documentos eliminados com sucesso.");
            }
        }).catch(() => {
            if ("function" === typeof errorCallback) {
                errorCallback("Ocorreu um erro a eliminar os documentos.");
            }
        });
    }

    deleteMultiple(filesName, successCallback, errorCallback) {
        const apiResult = DrawAPI.deleteMultiple(filesName);
        apiResult.then(() => {
            if ("function" === typeof successCallback) {
                successCallback("Documentos eliminados com sucesso.");
            }
        }).catch(() => {
            if ("function" === typeof errorCallback) {
                errorCallback("Ocorreu um erro a eliminar os documentos.");
            }
        });
    }
}
